import Vue, { VNode } from 'vue';
import { DirectiveBinding } from 'vue/types/options';
import { CombinedVueInstance } from 'vue/types/vue';

let clickOutsideEvent:any = null;

function bindClickOutside() {
	return (el: HTMLElement, binding: DirectiveBinding, vNode: VNode) => {
		clickOutsideEvent = (event: any) => {
			const target = event.target as HTMLTextAreaElement;
			const context: CombinedVueInstance<Vue, unknown, unknown, unknown, any> = vNode.context;
			if (!(el == target || el.contains(target)))
				context[binding.expression](false);
		};
		document.body.addEventListener('click', clickOutsideEvent);
	};
}

Vue.directive('click-outside', {
	bind: bindClickOutside(),
	unbind: function() {
		document.body.removeEventListener('click', clickOutsideEvent);
	},
});
